import { approvalTypeList, entityList } from '@/constants';
// import BASE_API from '@/api/dataBase';
export const searchColumns = (ctx) => {
  return [
    {
      prop: 'storageCode',
      name: '一级编码',
      type: 'input',
    },
    {
      prop: 'storageName',
      name: '一级名称',
      type: 'input',
    },
    {
      name: '是否专库',
      prop: 'isSpecial',
      type: 'dict',
      dictType: 'yes-no',
    },
    {
      prop: 'storageTypeCode',
      name: '仓库类型',
      type: 'select',
      options: ctx.storeType,
    },
    {
      prop: 'storageCreatePersonNo',
      name: '创建人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      isMultiple: true,
      changeMethod: ctx.changeCreatePersonMethod,
    },
    // {
    //   prop: 'storageCompanyCode',
    //   name: '所属组织',
    //   type: 'treeSelect',
    //   apiUrl: BASE_API.LIST_COMPANY_DEPT_TREE,
    //   // isName: true, // 是否返回名字
    //   // returnType: 'xx', // 全部返回当前对象
    //   // currentValue: '7024', // 默认选中的
    //   apiData: {
    //     tenantCode: ctx.userInfo.tenantCode,
    //     adminFlag: ctx.userInfo.adminFlag,
    //     selfCompanyDepartmentTreeFlag: true,
    //   },
    // },
    {
      prop: 'currentStatus',
      name: '审核状态',
      type: 'select',
      options: approvalTypeList,
    },
    {
      name: '是否实体',
      prop: 'isReality',
      type: 'select',
      options: entityList,
    },
  ];
};

// 默认表头
export const defaultTableColumn = [
  {
    type: 'checkbox',
    visible: true,
    width: '50',
    fixed: 'left',
  },
  // {
  //   type: 'seq',
  //   title: 'table.index',
  //   visible: true,
  //   width: '80',
  // },
  {
    field: 'storageCode',
    title: '一级编码',
    visible: true,
  },
  {
    field: 'storageName',
    title: '一级名称',
    visible: true,
  },
  {
    field: 'storageAddress',
    title: '一级地址',
    visible: true,
  },
  {
    field: 'storageCompanyName',
    title: '所属组织',
    visible: true,
  },
  {
    field: 'storageCreatePersonName',
    title: '创建人',
    visible: true,
  },
  {
    field: 'isSpecial',
    title: '是否专库',
    visible: true,
  },
  {
    field: 'storageCreateTime',
    title: '创建时间',
    visible: true,
  },
  {
    field: 'currentStatus',
    title: '状态',
    visible: true,
  },
];
